module.exports = __webpack_public_path__ + "img/donante-mexico.45e2f6a5.png";